import { useQuery } from "@tanstack/react-query";
import { fetcher } from "@/lib/api";
import { monthBounds } from "@/lib/format";

export const useSettings = () => useQuery({ queryKey: ["settings"], queryFn: () => fetcher("/settings") });

export const useTrips = () => useQuery({ queryKey: ["trips"], queryFn: () => fetcher("/trips") });

export const useTrip = (id) =>
  useQuery({ queryKey: ["trip", id], queryFn: () => fetcher(`/trips/${id}`), enabled: !!id, retry: false });

export const useAdminTrips = () => useQuery({ queryKey: ["admin-trips"], queryFn: () => fetcher("/admin/trips") });

export const useOccupancy = (tripId, month, extraDays = 0) => {
  const { start, end } = monthBounds(month, extraDays);
  return useQuery({
    queryKey: ["occupancy", tripId || "all", start, end],
    queryFn: () => fetcher("/availability", { start, end, trip_id: tripId || undefined }),
    staleTime: 15000,
  });
};
